export const PERMISSION_MAP_ALIAS = 'map::alias';
export const PERMISSION_SPOT_COLLECTION = 'map::spotcollection';

/**
 * @param {account['permissions']} permissionList
 * @param {typeof PERMISSION_MAP_ALIAS} permission
 */
export const hasPermission = (permissionList = [], permission) => {
  if (!permissionList.length) {
    return false;
  }

  for (let index = 0; index < permissionList.length; index++) {
    const p = permissionList[index];
    if (permission.indexOf(p) > -1) {
      return true;
    }
  }

  return false;
};
